export const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: 6,
  border: "1px solid #C0C7D6",
  fontSize: 14,
  boxSizing: "border-box",
  transition: "border-color 0.2s",
};

export const labelStyle = {
  fontSize: 14,
  fontWeight: 500,
  display: "block",
  color: "#333",
};
export const labelStyle12 = {
  fontSize: 12,
  fontWeight: 500,
  display: "block",
  color: "#333",
};

export const fieldStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 4,
};

export const errorStyle = {
  fontSize: 12,
  color: "#FF4D4F",
  display: "block",
};

export const inputWrapper = {
  position: "relative",
  width: "100%",
};

export const inputIcon = {
  color: "var(--color-on-base-content-high)",
  position: "absolute",
  left: "12px",
  top: "50%",
  transform: "translateY(-50%)",
  width: "16px",
  height: "16px",
  pointerEvents: "none",
  // opacity: 0.6,
};

export const wrapper = {
  width: "100%",
};

export const tabHeader = {
  display: "flex",
  gap: 24,
  padding: "0px 16px",
};

export const tabItem = {
  padding: "16px 0px",
  cursor: "pointer",
  fontSize: 16,
  fontWeight: 400,
  color: "#A7B1C4",
  borderBottom: "2px solid transparent",
  transition: "all .2s ease",
  maxHeight: "56px",
};

export const tabItemActive = {
  color: "var(--comp-btn-color-background-primary-normal)",
  borderBottom: "2px solid var(--comp-btn-color-background-primary-normal)",
};
